import React from "react";
import MyNavbar from "../../components/general/navbar/MyNavbar";
import HeroSection from '../homesections/hero/Hero';
import ConsultAISection from "../homesections/aisection/ConsultAI";
import DoctorsSection from "../homesections/doctors/Doctor";
import Card from "../homesections/cards/Card";
import Testimonials from './../../subscreen/patient/testimonials/Testimonials';
import Footer from "../../components/general/footer/Footer";
import VideoCalling from "../../subscreen/patient/videocalling/VideoCalling";
const Home=()=>{
    return(
        <>
        <MyNavbar/>
        <HeroSection/>
        <ConsultAISection/>
        <DoctorsSection/>
        <VideoCalling/>
        <Card/>
        <Testimonials/>
        <Footer/>
        </>
    );
}
export default Home;

